import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function Forbidden() {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  useEffect(() => {
    const timer = setTimeout(() => {
      logout({ logoutParams: { returnTo: "https://mypxch.com/" } });
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [logout]);

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gray-50 px-6">
      <div className="max-w-md text-center">
        <h1 className="text-9xl font-extrabold text-red-600">403</h1>
        <h2 className="mt-4 text-3xl font-bold text-gray-800">
          Forbidden Access
        </h2>
        <p className="mt-4 text-gray-600">
          Sorry, you don’t have permission to view this page. 
          <br />
          You will be logged out in <span className="font-bold">10 seconds</span>.
        </p>

        <div className="mt-8 flex justify-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="rounded-lg bg-gray-200 px-5 py-3 text-gray-700 transition hover:bg-gray-300"
          >
            ← Go Back
          </button>

          <button
            onClick={() => logout({ returnTo: window.location.origin })}
            className="rounded-lg bg-red-600 px-5 py-3 font-semibold text-white shadow-md transition hover:bg-red-700"
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
}
